<script>
  import API from '../Stores/API';
  import View from '../Stores/View';

  let context = '';

  function setAuthentication(event) {
    const form = event.target;
    const email = form.email.value;
    const password = form.password.value;
    API.setAuthentication(email, password);
  }
</script>

<style>
  .cover {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 30em;
  }

  .loader {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: inline-block;
    border-top: 5px solid #FFF;
    border-right: 5px solid transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>

{#if $API.initialized && !$API.authenticated}
  <section class="pt-6 bg-dark">
    <div class="container-lg">
      <div class="row justify-content-center">
        <div class="col-md-10 col-lg-8 text-center text-white">
          <h1 class="display-3 mb-4"><span class="text-underline-warning">Welkom Terug</span>: Bij de Eeuwige Tuinen!</h1>
          <p class="fs-lg">Hieronder kun je met jouw e-mailadres en wachtwoord inloggen om jouw Account, Abonnementen en Diensten te beheren.</p>
        </div>
      </div>
    </div>
  </section>
  <section class="position-relative pt-4 pb-10 bg-dark">
    <div class="container-lg">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6">
          {#if $API.attempted}
            <div class="alert alert-warning">Met deze gegevens kan niet ingelogd worden.</div>
          {/if}
          {#if $View.config.notice}
            <div class="alert alert-warning">{$View.config.notice}</div>
          {/if}
          <form on:submit|preventDefault="{setAuthentication}">
            <div class="form-group">
              <label class="visually-hidden" for="email">E-mail</label>
              <input class="form-control" id="email" type="email" required="required" placeholder="E-mailadres"/>
            </div>
            <div class="form-group">
              <label class="visually-hidden" for="password">Wachtwoord</label>
              <input class="form-control" id="password" type="password" required="required" placeholder="Wachtwoord"/>
            </div>
            <div class="form-group form-check">
              <input type="checkbox" class="form-check-input" id="persistent" checked="checked">
              <label class="form-check-label text-white" for="persistent">Op dit apparaat ingelogd blijven.</label>
            </div>
            <button class="btn w-100 mt-4 btn-primary-light">Inloggen</button>
            <a href="/wachtwoord/vergeten" class="btn w-100 mt-4 btn-primary">Wachtwoord Vergeten</a>
            <small class="mt-3 mx-5 text-primary-light d-block">Bij problemen met inloggen mag je altijd even <a class="eg-fancy text-primary-light" href="{context}/over-ons/contact">contact opnemen</a>.</small>
          </form>
        </div>
      </div>
    </div>
  </section>
{:else}
  <div class="cover bg-dark">
    <span class="loader"></span>
  </div>
{/if}